const scrollToElement = {
	el: {
		btnScroll: document.querySelectorAll('.js-scrollto'),
		header: document.querySelector('.header'),
		sticky: document.querySelector('.sticky'),
		aside: document.querySelector('.aside'),
		asideToggleMobile: document.querySelector('.js-toggle-aside'),
		accordion: document.querySelector('.accordion'),
		map: document.querySelector('.map')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},
	// polyfilled smooth scrolling for Edge & Safari
	fxSmoothScrollToPolyfill(to, duration) {
		const element = document.scrollingElement || document.documentElement,
			start = element.scrollTop,
			change = to - start,
			startDate = Number(new Date())

		// t = current time  b = start value  c = change in value d = duration
		const easeInOutQuad = (t, b, c, d) => {
			t /= d / 2
			if (t < 1) return c / 2 * t * t + b
			t--
			return -c / 2 * (t * (t - 2) - 1) + b
		}

		const animateScroll = () => {
			const currentDate = Number(new Date()),
				currentTime = currentDate - startDate

			element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration))
			currentTime < duration ? requestAnimationFrame(animateScroll) : element.scrollTop = to

		}
		animateScroll()
	},

	fxScrollTarget(target) {
		const headerHeight = this.el.header.offsetHeight,
			asideStickyHeight = this.el.asideToggleMobile ? this.el.asideToggleMobile.offsetHeight : 0,
			supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style,
			offsetTopElement = target.closest('.accordion') && this.el.map ? this.el.accordion.offsetParent.offsetTop + target.offsetTop : target.offsetTop

		if (supportsNativeSmoothScroll) {
			window.scrollTo({
				behavior: 'smooth',
				top: offsetTopElement - (this.el.header ? headerHeight : 0) - (this.el.asideToggleMobile && !this.vars.extraLargeAndUp.matches ? asideStickyHeight : 0) + 1
			})
		}
		else
			this.fxSmoothScrollToPolyfill(target.offsetTop - (this.el.header ? headerHeight : 0) - (this.el.asideToggleMobile && !this.vars.extraLargeAndUp.matches ? asideStickyHeight : 0) + 1, 500)
	},

	fxScrollTo(btnScrollTo, target) {
		btnScrollTo.forEach(button => button.addEventListener('click', e => {
			e.preventDefault()
			const searchContainer = button.closest('.js-search') ? button.closest('.js-search') : button.closest('.modal') ? button.closest('.modal').previousElementSibling : button.closest('.pagination') ? button.closest('.pagination').previousElementSibling : ''

			const isMapContainer = button.closest('.map') ? button.closest('.map') : ''

			target = btnScrollTo === this.el.btnScroll ? document.getElementById(button.dataset.scroll) : (searchContainer.querySelector('.js-autocomplete') ? searchContainer.querySelector('.js-autocomplete') : searchContainer)

			if (target) {
				if (isMapContainer) {
					document.querySelectorAll('.js-toggle-accordion').forEach(el => el.classList.remove('is-toggled'))
					document.querySelectorAll('.accordion__panel').forEach(el => el.classList.remove('is-toggle-open'))
					target.children[0].click()
				}
				this.vars.extraLargeAndUp.matches ? this.fxScrollTarget(target) : setTimeout(() => this.fxScrollTarget(target), 500)
				btnScrollTo.forEach(el => el.classList.remove('is-active'))
				e.currentTarget.classList.add('is-active')
				if ((this.el.aside || this.el.sticky) && !this.vars.extraLargeAndUp.matches) {
					this.el.sticky ? this.el.sticky.classList.remove('is-aside-open') : ''
					this.el.aside ? this.el.aside.classList.remove('is-aside-open') : ''
				}
			}
		}))
	},

	events() {
		this.fxScrollTo(this.el.btnScroll, this)
	},

	init() {
		this.events()
	}
}

scrollToElement.init()